import { render, staticRenderFns } from "./ComplaintMediaDetail.vue?vue&type=template&id=bc8b7e54&"
import script from "./ComplaintMediaDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintMediaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports